import React from 'react';
import { ChevronRight } from 'lucide-react';
import { SecondaryButton } from 'src/shared/components/button/Button';
import { cn } from 'src/shared/helpers/utils';

export type ExploreButtonProps = {
    buttonText?: string;
    sectionName?: string;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
    iconClassName?: string;
};

const ExploreButton = ({ buttonText, onClick, disabled, className, iconClassName }: ExploreButtonProps) => {
    const handleExploreClick = () => {
        onClick?.();
    };

    return (
        <SecondaryButton
            className={cn('flex items-center gap-2 p-2 h-[30px] text-xs', className)}
            onClick={handleExploreClick}
            disabled={disabled}
        >
            {buttonText || 'Explore'} <ChevronRight className={cn(disabled ? 'text-grey-80' : 'text-primary', iconClassName)} />
        </SecondaryButton>
    );
};

export default ExploreButton;
